/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.note', ['popup', 'data.note']);
